import "../App.css";
import React, { useState } from "react";

import Slider from "../component/slider";
import Fetures from "../component/feture";
import AboutVedio from "../component/about-vedio";
import CountSection from "../component/count-section";
import Testimonials from "../component/testimonials";
import YoutubeSection from "../component/youTubeSection";
import ContactUs from "../component/contact-us";

import PopupImage from "../img/popup-image.jpeg";

function Home() {
  const [showPopup, setShowPopup] = useState(true);

  const APP_DOWNLOAD_LINK =
    "https://play.google.com/store/search?q=moverstrip&c=apps&hl=en_IN";

  const handlePopupClick = () => {
    window.open(APP_DOWNLOAD_LINK, "_blank");
  };

  return (
    <>
      {/* POPUP ADVERTISEMENT */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-container">

            {/* CLOSE BUTTON */}
            <button
              className="popup-close-btn"
              onClick={() => setShowPopup(false)}
              aria-label="Close advertisement"
            >
              ×
            </button>

            {/* CLICKABLE ADVERTISEMENT IMAGE */}
            <img
              src={PopupImage}
              alt="Download Moverstrip App"
              className="popup-image"
              onClick={handlePopupClick}
              style={{ cursor: "pointer" }}
            />

          </div>
        </div>
      )}

      {/* WEBSITE CONTENT */}
      <main id="main">
        <Slider />
        <Fetures />
        <AboutVedio />
        <CountSection />
        <Testimonials />
        <YoutubeSection />
        <ContactUs />
      </main>
    </>
  );
}

export default Home;